export const FinancialValues = [
    {
        name: 'Security',
        description: `Have a fully funded emergency fund, save for retirement`
    },
    {
        name: 'Freedom',
        description: `achieve financial independence ASAP by cutting living expenses and increasing income/savings rate`
    },
    {
        name: 'Travel',
        description: `save monthly for one big trip per year`
    },
    {
        name: 'Homemaking',
        description: `save a down payment, improve credit score`
    },
    {
        name: 'Family',
        description: `live on one income so one parent can be at home full-time`,
    },
    {
        name: 'Health',
        description: `pay for a gym membership and healthy food by cutting expenses in other areas`
    },
    {
        name: 'Helping others',
        description: `Give a certain amount of money each month to an organization`,
    },
]